import React from "react"
import FormGroup from "../../../Form/FormGroup"
import Select from "../../../Form/Select"
import { listAssignTo } from "../../../../schemas/Chat"
import { useData } from "../../../../contexts/dataContext"
import Textarea from "../../../Form/Textarea"

const TransferService = ({ data = {}, onChange = () => { } }) => {
    const { teams, roles, users } = useData()

    const handleChangeContent = (name, value) => {
        onChange(name, value)
    }

    return (
        <FormGroup>
            <FormGroup labelText="Transferir para quem?">
                <Select
                    name="Transferir para quem?"
                    placeholder="Selecione uma opção..."
                    options={[{ id: "default", value: "Utilizar atribuição padrão da caixa de entrada" }, ...listAssignTo]}
                    selected={data.assign_to ?? ""}
                    onChange={(value) => handleChangeContent("assign_to", value)}
                    multiple={false}
                />
            </FormGroup>
            {data?.assign_to === "teamAndRole" &&
                <>
                    <FormGroup labelText="Equipe">
                        <Select name="Selecione uma opção..." placeholder="Pesquisar..." options={teams} selected={data?.team_id ?? ""} multiple={false} onChange={(value) => handleChangeContent("team_id", value)} />
                    </FormGroup>
                    <FormGroup labelText="Cargo">
                        <Select name="Selecione uma opção..." placeholder="Pesquisar..." options={roles} selected={data?.role_id ?? ""} multiple={false} onChange={(value) => handleChangeContent("role_id", value)} />
                    </FormGroup>
                </>
            }
            {data?.assign_to === "users" &&
                <FormGroup labelText="Usuários">
                    <Select name="Usuários" placeholder="Pesquisar..." options={users} selected={data?.users ?? []} multiple={true} onChange={(value) => handleChangeContent("users", value)} />
                </FormGroup>
            }
            <FormGroup labelText="Mensagem de transferência">
                <Textarea
                    placeholder="Ex: Vou te transferir para um de nossos atendentes. Um momento, por favor!"
                    onChange={(e) => handleChangeContent("transfer_message", e.target.value)}
                    value={data?.transfer_message || ""}
                    rows={3}
                />
            </FormGroup>
        </FormGroup>
    )
}

export default TransferService